// The server refuses a list move with a 4xx + message, e.g. when the list's mandatory checklist is not done
// (code MANDATORY_CHECKLIST_INCOMPLETE). Returns that message, or null for any other error.
export const getMoveBlockedMessage = (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    if (!status || status < 400 || status >= 500) return null;
    if (status === 401 || status === 403) return null;
    return data?.message || data?.error || 'This ticket cannot be moved yet';
};
